import { render, staticRenderFns } from "./XQSQ.vue?vue&type=template&id=7c8f7ccc&scoped=true"
import script from "./XQSQ.vue?vue&type=script&lang=js"
export * from "./XQSQ.vue?vue&type=script&lang=js"
import style0 from "./XQSQ.vue?vue&type=style&index=0&id=7c8f7ccc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f7ccc",
  null
  
)

export default component.exports